// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.jsx";
import * as Caml_option from "melange.js/caml_option.jsx";
import * as Fx from "../fx/fx.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as StoreFx__InitializePlayQueue from "./initializePlayQueue.jsx";
import * as StoreFx__PlayerContext from "./playerContext.jsx";
import * as Subsonic__CoverArt from "../api/subsonic/coverArt.jsx";
import * as Subsonic__Scrobble from "../api/subsonic/scrobble.jsx";
import * as Subsonic__StreamUrl from "../api/subsonic/streamUrl.jsx";

const timePlayed = {
  contents: 0.0
};

function make(param) {
  return Fx.Monad_syntax.let$star(Fx.ask(undefined), (function (param) {
    param.store.subscribe(function (state, prevState) {
      if (state.player.currentTime !== prevState.player.currentTime || state.player.duration !== prevState.player.duration) {
        const duration = state.player.duration;
        if (duration !== undefined) {
          navigator.mediaSession.setPositionState({
            duration: duration,
            position: Math.min(state.player.currentTime, duration)
          });
        }
        
      }
      if (state.player.currentSongId === prevState.player.currentSongId && state.player.currentTime !== prevState.player.currentTime) {
        if (StoreFx__PlayerContext.skipping.contents) {
          StoreFx__PlayerContext.skipping.contents = false;
        } else if (state.player.currentTime > prevState.player.currentTime) {
          timePlayed.contents = timePlayed.contents + state.player.currentTime - prevState.player.currentTime;
        }
        
      }
      if (state.auth.credentials !== prevState.auth.credentials || state.player.currentSongId !== prevState.player.currentSongId) {
        const match = state.auth.credentials;
        const match$1 = state.player.currentSongId;
        const src = match !== undefined && match$1 !== undefined ? Subsonic__StreamUrl.make(match, match$1) : "";
        if (StoreFx__PlayerContext.audio.src !== src) {
          StoreFx__PlayerContext.audio.src = src;
        }
        
      }
      const song = Stdlib__Option.bind(state.player.currentSongId, (function (currentSongId) {
        return Caml_option.undefined_to_opt(state.songs.byId.get(currentSongId));
      }));
      if (state.player.currentSongId !== prevState.player.currentSongId) {
        const match$2 = state.auth;
        const credentials = match$2.credentials;
        const metadata = new MediaMetadata();
        if (credentials !== undefined && song !== undefined) {
          metadata.album = song.album;
          metadata.artist = song.artist;
          metadata.title = song.title;
          metadata.artwork = [
            96,
            128,
            192,
            256,
            384,
            undefined
          ].map(function (size) {
            const src = Subsonic__CoverArt.makeUrl(credentials, song.coverArt, size, undefined);
            let sizes;
            if (size !== undefined) {
              const size$1 = size.toString(undefined);
              sizes = size$1 + ("x" + size$1);
            } else {
              sizes = "";
            }
            return {
              sizes: sizes,
              src: src
            };
          });
        }
        window.navigator.mediaSession.metadata = metadata;
      }
      if (state.player.currentSongId !== prevState.player.currentSongId || state.player.replayGainOptions !== prevState.player.replayGainOptions) {
        const match$3 = Stdlib__Option.value(Stdlib__Option.bind(song, (function (x) {
          return x.replayGain;
        })), {
          albumGain: undefined,
          albumPeak: undefined,
          trackGain: undefined,
          trackPeak: undefined
        });
        const trackPeak = match$3.trackPeak;
        const trackGain = match$3.trackGain;
        const albumPeak = match$3.albumPeak;
        const albumGain = match$3.albumGain;
        const gain = Stdlib__Option.value(Stdlib__Option.bind(state.player.replayGainOptions.preferredGain, (function (param) {
          if (param === "album") {
            return Belt__Belt_Option.orElse(trackGain, albumGain);
          } else {
            return Belt__Belt_Option.orElse(albumGain, trackGain);
          }
        })), 0.0);
        const peak = Stdlib__Option.value(Stdlib__Option.bind(state.player.replayGainOptions.preferredGain, (function (param) {
          if (param === "album") {
            return Belt__Belt_Option.orElse(trackPeak, albumPeak);
          } else {
            return Belt__Belt_Option.orElse(albumPeak, trackPeak);
          }
        })), 1.0);
        const newReplayGainValue = Math.min(Math.pow(10.0, (gain + state.player.replayGainOptions.preAmp) / 20.0), 1.0 / peak);
        StoreFx__PlayerContext.replayGainValue.contents = newReplayGainValue;
        Stdlib__Option.iter((function (v) {
          v.replayGainNode.gain.setValueAtTime(newReplayGainValue, v.audioContext.currentTime);
        }), StoreFx__PlayerContext.value.contents);
      }
      const match$4 = state.auth.credentials;
      const match$5 = state.player.currentSongId;
      if (match$4 !== undefined && match$5 !== undefined && !state.player.paused && (state.player.currentSongId !== prevState.player.currentSongId || state.player.paused !== prevState.player.paused)) {
        const arg = {
          credentials: state.auth.credentials
        };
        ((function (param) {
            return Fx.runAsync(param, arg);
          })(Subsonic__Scrobble.make(match$5, false, undefined, undefined)));
      }
      const match$6 = state.player.currentSongId;
      const match$7 = prevState.player.currentSongId;
      Stdlib__Option.iter((function (param) {
        const prevSongId = param[1];
        if (param[0] === prevSongId) {
          return;
        }
        const match = state.auth.credentials;
        const match$1 = prevState.player.duration;
        if (match !== undefined && match$1 !== undefined) {
          if (match$1 >= 30.0 && (timePlayed.contents / match$1 >= 0.5 || timePlayed.contents >= 4.0 * 60.0)) {
            Fx.runAsync(Subsonic__Scrobble.make(prevSongId, undefined, undefined, undefined), {
              credentials: match
            });
          }
          timePlayed.contents = 0.0;
          return;
        }
        
      }), match$6 !== undefined && match$7 !== undefined ? [
          match$6,
          match$7
        ] : undefined);
    });
    return StoreFx__InitializePlayQueue.make(undefined);
  }));
}

export {
  timePlayed,
  make,
}
/* StoreFx__InitializePlayQueue Not a pure module */
